exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner[data-v-3c77aeea] {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border-left-color: #3b82f6;\n  animation: spin-3c77aeea 1s linear infinite;\n  margin: 0 auto;\n}\n@keyframes spin-3c77aeea {\n0% {\n    transform: rotate(0deg);\n}\n100% {\n    transform: rotate(360deg);\n}\n}\n.supergroup-tree[data-v-3c77aeea] {\n  margin-left: -1rem;\n}\n.odd[data-v-3c77aeea] {\n  background: rgb(245, 245, 245);\n}\n.even[data-v-3c77aeea] {\n  background: white;\n}\n.mb-3[data-v-3c77aeea] {\n  margin-bottom: 12px;\n}\n.mb-4[data-v-3c77aeea] {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
